import { render, staticRenderFns } from "./RoutePlay.vue?vue&type=template&id=7c1cd1ac&scoped=true"
import script from "./RoutePlay.vue?vue&type=script&lang=js"
export * from "./RoutePlay.vue?vue&type=script&lang=js"
import style0 from "./RoutePlay.vue?vue&type=style&index=0&id=7c1cd1ac&prod&lang=scss"
import style1 from "./RoutePlay.vue?vue&type=style&index=1&id=7c1cd1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1cd1ac",
  null
  
)

export default component.exports